'use client';

import { motion, useReducedMotion } from 'motion/react';
import type { ReactNode } from 'react';

const shift = 8;
const sec = 0.2;

export function staggerDelay(index: number) {
  return Math.min(index, 7) * 0.04;
}

export function SectionReveal({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y: shift }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: sec, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  );
}

export function StepBody({
  stepKey,
  children,
}: {
  stepKey: string;
  children: ReactNode;
}) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      key={stepKey}
      initial={reduce ? false : { opacity: 0, y: shift }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: sec, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  );
}

export function FadeIn({ children, delay = 0 }: { children: ReactNode; delay?: number }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      initial={reduce ? false : { opacity: 0, y: shift }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: sec, ease: 'easeOut', delay: reduce ? 0 : delay }}
    >
      {children}
    </motion.div>
  );
}

export function ModalMotion({ children }: { children: ReactNode }) {
  const reduce = useReducedMotion();
  return (
    <motion.div
      initial={reduce ? false : { opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: sec, ease: 'easeOut' }}
    >
      {children}
    </motion.div>
  );
}
